import React from 'react';
import { SelectInput, useRecordContext } from 'react-admin';

import locales from '../../../services/locales';

const choices = locales.map(locale => ({ id: locale, name: locale?.toUpperCase() }));

const LanguageInput = ({ classes, source, ...props }) => {
	const record = useRecordContext();

	return (
		<SelectInput source={source} choices={choices} record={record} {...props} />
	);
};

LanguageInput.defaultProps = {
	source: 'lang'
};

export default LanguageInput;
